export const videoTableVisibility = {
    EVERYONE: "Todos",
    INTERNAL_USERS: "Usuários internos",
    AUTHENTICATED_USERS: "Usuários autenticados",
  };
  export default videoTableVisibility;